// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"234":"4b14b8ba","567":"4b14b8ba"}[chunkId] + ".chunk.css");